import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { ZIndexLayer } from "~/lib/styles";

import { StoryCardCarouselWidgetDisplayHeading } from "./heading";
import StyleCardCarouselTagIcon from "./style-card-carousel-tag-icon.svg";

export const StyledStoryCardCarouselWidgetDisplayHeading = styled(
  StoryCardCarouselWidgetDisplayHeading,
)(
  props => css`
    display: none;
    ${props.theme.breakpoints.up("tablet")} {
      display: flex;
    }
  `,
);

export const Container = styled.div`
  position: sticky;
  inset-block-end: 0;
  inset-inline-start: 0;
  z-index: ${ZIndexLayer.StoryCardCarouselWidget};

  display: flex;
  align-items: flex-start;

  inline-size: 100%;

  background-color: #f6f6f6;

  overflow: hidden;

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 132px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    block-size: 156px;

    background-color: rgba(246, 246, 246, 0.98);
  }
`;

export const Wrapper = styled.div`
  display: flex;

  inline-size: 100%;
  ${props => props.theme.breakpoints.up("tablet")} {
    gap: 32px;
    align-items: center;

    inline-size: unset;
    margin: auto;
  }
`;

export const StyledLabelIcon = styled(StyleCardCarouselTagIcon)`
  inline-size: 13px;
  block-size: 92px;
  margin-block-start: 10px;
  margin-inline: 8px 0;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const CarouselContainer = styled.div`
  display: flex;

  inline-size: 100%;
  margin-block-start: 6px;
  padding-block: 0;
  padding-block-end: 10px;
  padding-inline-start: 8px;

  overflow-x: auto;
`;

export const ItemContainer = styled.div`
  inline-size: 72px;
  margin-inline-end: 8px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: unset;
    margin-inline-end: 9px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-inline-end: 10px;
  }
`;
